{
  "variants": {
    "Hover": true,
    "Mobile": true,
    "State": true,
    "Selected": true,
    "Trigger": true,
    "Preset": true,
    "RepeaterPattern": true,
    "BreakpointRange": true,
    "NamedRange": true
  },
  "data": {
    "AppController": true,
    "TPAWidget": true,
    "TPA": true,
    "TPAMultiSection": true,
    "Page": true,
    "AppPage": true,
    "CustomMenu": true,
    "LoginSocialBar": true,
    "PagesGroupData": true
  },
  "variables": {
    "UnitSizeVar": true,
    "LayoutSizeVar": true,
    "HeightVar": true,
    "PositionTypeVar": true,
    "NumberVar": true,
    "ItemsAlignmentVar": true,
    "KeywordLengthVar": true,
    "JustifyContentVar": true,
    "NumVar": true,
    "LengthVar": true,
    "PositiveLengthVar": true,
    "AngleVar": true,
    "ColorVar": true,
    "PercentageVar": true,
    "BorderEdgeStyleVar": true,
    "BorderEdgeWidthVar": true,
    "BorderWidthVar": true,
    "BorderStyleVar": true,
    "BorderColorVar": true,
    "BorderVar": true,
    "BorderCornerRadiusVar": true,
    "BorderRadiusVar": true,
    "FontVar": true,
    "FontSizeVar": true,
    "FontStretchVar": true,
    "FontStyleVar": true,
    "FontVariantVar": true,
    "FontWeightVar": true,
    "FontFamilyVar": true,
    "LineHeightVar": true,
    "LetterSpacingVar": true,
    "TextAlignVar": true,
    "TextTransformVar": true,
    "TextShadowVar": true,
    "TextDecorationVar": true,
    "TextDecorationLineVar": true,
    "TextDecorationStyleVar": true,
    "TextDecorationThicknessVar": true,
    "TextIndentVar": true,
    "PaddingVar": true,
    "PaddingEdgeVar": true,
    "MarginVar": true,
    "MarginEdgeVar": true,
    "BoxShadowVar": true,
    "OpacityVar": true,
    "CssJustifyContentVar": true,
    "BackgroundVar": true,
    "WritingModeVar": true,
    "DisplayVar": true,
    "FilterVar": true,
    "GapVar": true,
    "SingleValueGapVar": true
  },
  "components": {
    "Component": true,
    "Container": true,
    "RefComponent": true,
    "RepeaterContainer": true
  },
  "effects": {
    "TimeAnimation": true,
    "ScrubAnimation": true
  }
}
